<template>
  <a-card :loading="false" class="mp-main">
    <div slot="title" class="m-display-flex space-between custom">
      <span class="cmain-title"><a-icon type="project" />&nbsp;Cash Management - Monthly Plafon</span>
      <div></div>
    </div>
    <a-tabs :defaultActiveKey="tabActive" type="card" class="mp-main-tab" @change="callbackTab">
      <a-tab-pane tab="Plafon Plan" key="rencana">
        <monthlyPlafonPlan v-if="tabActive=='rencana'"/>
      </a-tab-pane>
      <a-tab-pane tab="Plafon Lialibilities" key="kewajiban">
        <monthlyLiabilities v-if="tabActive=='kewajiban'"/>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
import monthlyPlafonPlan from "./monthlyPlafonPlan_header"
import monthlyLiabilities from "./monthlyLiabilities_header"

export default {
  name: "monthlyPlafon",
  components: {
    monthlyPlafonPlan,
    monthlyLiabilities
  },
  mixins: [],
  data() {
    return {
      tabActive: 'rencana'
    }
  },
  methods:{
    callbackTab(val){
      this.tabActive = val
    }
  },
  created(){},
  mounted(){},
  beforeDestroy(){}
}
</script>
<style lang="less" scope>
.mp{
  &-main{
    &-tab{
      .ant-tabs-bar{
        margin: 0 0 3px 0!important;
      }
    }
  }
}
</style>